<div id="header_view" class="page-main-header" [ngClass]="{'sidebar-opened' : !open}" [class.open]="open">
    <div class="main-header-right row">
        <div class="main-header-left d-lg-none">
            <div class="logo-wrapper d-flex justify-content-center">
                <img class="svg-icon d-flex justify-content-center" alt="" src="assets/images/{{logo}}" style="width: auto; height: 30px">
            </div>
        </div>
        <div class="mobile-sidebar">
            <div class="media-body text-right switch-sm">
                <label class="switch">
                    <a class="cursor">
                        <app-feather-icons id="sidebar-toggle" [icon]="'align-left'" (click)="collapseSidebar()">
                        </app-feather-icons>
                    </a>
                </label>
            </div>
        </div>

        <div class="logo-wrapper d-flex justify-content-center" *ngIf="open">
            <img (click)="navigateToDefaultPages()" alt="" class="blur-up lazyloaded" src="assets/images/{{logo}}" style="width: auto; height: 34px;">
        </div>
        <div class="nav-right col">
            <ul style="justify-content: space-between" class="nav-menus" [ngClass]="{'open' : openNav}">
                <div *ngIf="auth.loggedIn()" style="position: absolute" class="col-{{roleid == '3' || roleid == '6' ? '2' : '8'}} pr-4"
                     [ngStyle]="{'visibility': !showPaymentMessage() ? 'hidden' : ''}">
                    <div class="marquee">
                        <div style="color: red"> Dear Customer, Your subscription is due for renewal. Kindly make the
                            payment <a class="payment-color" href="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-8YL46966WX816621MMWSYSKQ"
                                       target="_blank">here</a> before <span>{{showDate()}}</span> to continue with the service.
                        </div>
                    </div>
                </div>
                <div style="position: absolute; right: 0" class="d-flex align-items-center justify-content-end">
                    <li class="mr-3" *ngIf="auth.getRoleId() == '2' || auth.getRoleId() == '5' && auth.showBackToAdminMenu">
                        <button *ngIf="auth.showBackToAdminMenu" class="btn cancel mr-2 btn-sm px-2" (click)="auth.backToAdmin()">
                            <i class="fa fa-long-arrow-left mr-2"></i>Back To Admin Login</button>
                        <button *ngIf="!auth.showBackToAdminMenu" class="btn cancel mr-2 btn-sm px-2" [routerLink]="'/login/asStudent'">
                            Login As Student<i class="fa fa-long-arrow-right ml-2"></i></button>
                    </li>
                    <li class="mr-4">
                        <div class="row" *ngIf="['2', '4', '5'].indexOf(roleid) > -1">
                            <select *ngIf="schoolName.length > 1" [disabled]="!allowSelect" class="form-control" (change)="schoolChangeList($event.target.value)" [(ngModel)]="sclName">
                                <option *ngFor="let school of schoolName" [value]="school.school_id">{{school.name}}</option>
                            </select>
                            <h6 *ngIf="schoolName.length == 1" class="school_name_design col-12">
                                {{schoolName[0].name}}</h6>
                        </div>
                        <div class="row d-inline-flex align-items-center" *ngIf="['3', '6'].includes(roleid)">
                            <span class="f-14 color-primary">{{name}}</span>
                            <span class="f-12 mx-2" *ngIf="roleid == 6">({{corporateCode}})</span>
                            <select *ngIf="overallData != '' && roleid == 6 && !hideSchoolDropdown && schoolName.length > 1"
                                    [disabled]="!allowSelect" class="form-control w-auto" (change)="schoolChangeList($event.target.value)" [(ngModel)]="sclName">
                                <option *ngFor="let school of schoolName; let i = index" [value]="school.school_id">{{school.name}}</option>
                            </select>
                            <h6 *ngIf="overallData != '' && roleid == 6 && !hideSchoolDropdown && schoolName.length == 1"
                                class="school_name_design my-0 px-0">{{schoolName[0]?.name}}</h6>
                        </div>
                    </li>
                    <li>
                        <a href="javascript:void(0)" class="text-dark" toggleFullscreen>
                            <app-feather-icons [icon]="'maximize-2'"></app-feather-icons>
                        </a>
                    </li>
                    <li class="onhover-dropdown mx-3">
                        <div class="media align-items-center">
                            <img class="align-self-center pull-right img-30 rounded-circle"
                                 *ngIf="profile == '' || profile == null" src="assets/images/dashboard/default.png"
                                 alt="">
                            <img class="align-self-center pull-right img-30 rounded-circle"
                                 *ngIf="profile != '' && profile != null && !listCheck" style="height: 30px"
                                 src="{{imgUrl +'/'+ profile}}" alt="">
                            <img class="img-30 rounded-circle" *ngIf="profile != '' && listCheck" style="height: 30px"
                                 [src]="profile" alt="">
                        </div>
                        <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                            <li *ngIf="roleid == '2' || roleid == '3' || roleid == '4' || roleid == '6'"><a
                                    [routerLink]="'/settings/profile/view'">
                                <app-feather-icons [icon]="'user'"></app-feather-icons>
                                My Profile
                            </a></li>
                            <li *ngIf="roleid == '5'"><a [routerLink]="'/studentlogin/profile/view'">
                                <app-feather-icons [icon]="'user'"></app-feather-icons>
                                My Profile
                            </a></li>
                            <li *ngIf="!auth.showBackToAdminMenu" ><a [routerLink]="'/users/change-password'">
                                <app-feather-icons [icon]="'mail'"></app-feather-icons>
                                Change Password
                            </a></li>
                            <li *ngIf="!auth.showBackToAdminMenu"><a (click)="logout()">
                                <app-feather-icons [icon]="'log-out'"></app-feather-icons>
                                Logout
                            </a></li>
                        </ul>
                    </li>
                    <li>
                        <h6 *ngIf="['2', '3', '4', '5', '6'].indexOf(roleid) > -1" class="letter mt-2">
                            Welcome {{name}}</h6>
                    </li>
                </div>
            </ul>
        </div>
    </div>
</div>
